import { IEditMessage } from '../../types';
import { OperateType } from '../../types/operate';
import { parseWsKey } from '../../utils';
import { Collaborators } from '../collaborators';
import { Room } from '../room';

/**
 * 选中图层操作
 */
export class PickLayer {
    constructor(
        private room: Room,
        private collaborators: Collaborators,
    ) {
        this.room.onMessage(OperateType.PickLayer, this.onReceivePickLayer.bind(this));
    }

    /** 发送选中图层事件 */
    send(activeId = '', pickId = '') {
        this.collaborators.getMember()?.setPickInfo(activeId, pickId);
        this.room.sendToAll(OperateType.PickLayer, [activeId, pickId]);
    }

    /** 收到选中图层事件回调 */
    private onReceivePickLayer({ fromWsMemberKey, data }: IEditMessage<string[]>) {
        const [layerId, pickId] = data;
        const { wsKey } = parseWsKey(fromWsMemberKey);
        this.collaborators.getMember(wsKey)?.setPickInfo(layerId, pickId);
        this.room.renderUserPick();
    }
}
